import React from 'react';
import AnimatedBackground from '../Assets/template/NIA2.gif';

const AboutSection = () => {
  return (
    <div style={styles.aboutContainer}>
      {/* GIF Background */}
      <img
        src={AnimatedBackground}
        alt="Background"
        style={styles.videoBackground}
      />

      {/* Content Overlay */}
      <div style={styles.overlay}>
        <div style={styles.leftText}>
          <div style={styles.centerText}>
            <div style={styles.aboutLabel}>ABOUT</div>
            <h2 style={styles.aboutSubtitle}>DISA</h2>
            <p style={styles.italicBoldText}>
              "Digital Irrigator System<br />Assessment"
            </p>
          </div>
        </div>
        <div style={styles.rightText}>
          <p style={styles.aboutDescription}>
            An innovative platform that leverages advanced technologies to optimize irrigation systems across Bohol. By analyzing climate patterns, water usage, and crop needs, DISA ensures a more efficient and sustainable water distribution system for farmers. This empowers local agriculture, enhances crop yields, and strengthens food security, driving innovation in the country's farming practices.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;

const styles = {
  aboutContainer: {
    position: 'relative',
    minHeight: '100vh',
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter, sans-serif',
  },
  videoBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover', // Maintains video clarity
    zIndex: 0,
    transform: 'scale(1.02)', // Slight upscale to reduce compression blur
  },
  overlay: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '90%',
    maxWidth: '1300px',
    flexWrap: 'wrap',
    color: '#fff',
    alignItems: 'flex-start',
  },
  leftText: {
    flex: '1',
    minWidth: '300px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#bfff00',
  },
  centerText: {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  textAlign: 'left',
  height: '100%',
  marginLeft: '60px',
  marginTop: '120px', // ⬅️ Moved lower
},
aboutLabel: {
  fontWeight: 900,
  fontSize: '40px', // ⬅️ Bigger
  color: '#fff',
  marginBottom: '15px',
  letterSpacing: '1.5px',
  textShadow: '3px 3px 8px rgba(0, 0, 0, 0.7)',
  marginLeft: '-50px',
  textTransform: 'uppercase',
},
aboutSubtitle: {
  fontWeight: 1100,
  fontSize: '120px', // ⬅️ Bigger
  fontFamily: 'Poppins, sans-serif',
  letterSpacing: '4px',
  color: '#28a745',
  textShadow: '10px 2px 0 #e0f0ff, 0 0 10px rgba(0,0,0,0.5)',
  margin: '10px 0',
  textTransform: 'uppercase',
  textAlign: 'left',
},
italicBoldText: {
  fontWeight: 900,
  fontSize: '30px', // ⬅️ Bigger
  lineHeight: '1.4',
  letterSpacing: '5px',
  color: '#28a745',
  textShadow: '2px 2px 0 #e0f0ff, 0 0 8px rgba(12, 109, 12, 0.1)',
  marginBottom: '15px',
  fontStyle: 'italic',
},

  rightText: {
    flex: '1',
    minWidth: '300px',
    padding: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '30px',
  },
  aboutDescription: {
  fontWeight: 600, // Bold for visibility
  fontSize: '25px',
  lineHeight: '1.8',
  letterSpacing: '0.2px',
  textAlign: 'justify',
  color: '#fefffeff', // Green font color
  maxWidth: '600px',
  padding: '40px',
  backgroundColor: 'rgba(7, 71, 21, 0.1)', // Soft translucent white background
  borderRadius: '12px', // Rounded edges for visual polish
  fontFamily: 'Inter, Sans-serif',
  textShadow: '0.5px 0.5px 1px rgba(26, 24, 24, 0.7)', // Thin white shadow
},
};